import { httpClientVendasCoreBff } from 'vendas-core/shared/services'
import { type WebhookItem } from 'webhooks/shared/entities'

import { useQueryRequest } from '~/ui/hooks/utils'

export function useGetWebhook(
  paymentProfileId: string | undefined,
  webhookId: string,
  options?: { enabled?: boolean }
) {
  const { data: response, ...rest } = useQueryRequest<WebhookItem>(
    ['useGetWebhook', paymentProfileId, webhookId],
    () =>
      httpClientVendasCoreBff<WebhookItem>({
        url: `/v1/payment-profile/${paymentProfileId}/webhooks/settings/${webhookId}`,
        method: 'GET'
      }),
    {
      enabled: Boolean(paymentProfileId) && Boolean(webhookId) && (options?.enabled ?? true)
    }
  )

  return { data: response?.data, ...rest }
}
